import React, { useState, useEffect } from 'react'
import { Panel, Message } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import { startLoading, doneLoading } from '../../utils/loading'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import moment from 'moment'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'
import ButtonPanelWidget from '../ButtonPanelWidget'
import ProjectBasicInfo from '../projectBasicInfo/ProjectBasicInfo'
import LawApproveProposal from './LawApproveProposal'

export default function LawApproveWidget(props) {
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()
  const [section, setSection] = useState()
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(props.schema)
  const [dataTable, setDataTable] = useState()
  const [searchLawData, setSearchLawData] = useState(null)
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const [litigationId, setLitigationId] = useState(null)
  const [errorMsg, setErrorMsg] = useState()
  const [clearValue, setClearValue] = useState(false)

  return (
    <>
      <ProjectBasicInfo schema={formSchema.projectInfo} />

      <br />

      <LawApproveProposal schema={formSchema.offeringApproveProposal} />
    </>
  )
}
